import { useMemo } from 'react';
import { useStoreLocationSearch } from '~/shared/hooks/useStoreLocationSearch';
import { findClosestStores } from '~/shared/utils/findClosestStores';
import type { Store } from '~/lib/data-contract/salesforce';

// Wide enough to cover all of Denmark, so the country-wide distance sort never drops a store.
const ALL_DENMARK_RADIUS_KM = 1000;

export const useStoreAvailabilitySearch = (allStores?: Store[]) => {
    const { activeLocation, ...search } = useStoreLocationSearch();

    // Distance sort only. The radius is wide enough that no store is ever filtered out.
    const nearbyStores = useMemo(() => {
        if (!activeLocation || !allStores) return allStores;

        return findClosestStores(activeLocation.coordinates, allStores, ALL_DENMARK_RADIUS_KM);
    }, [activeLocation, allStores]);

    return { ...search, nearbyStores };
};
